import APIClient from '@/shared/http/clients/api'

const resourceName = 'relatorio/followup'
const APICore = process.env.APIBaseURLCore

const GetAll = (filters, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, filters, config)
const GetAllCardsReport = (dataFilters, limit, index, config = {}) => APIClient.post(`${APICore}/${resourceName}/?page=${index}&size=${limit}&sort=data,DESC`, dataFilters, config)
const ExportAllCardsReport = (dataFilters, config = {}) => APIClient.post(`${APICore}/${resourceName}/export`, dataFilters, config)

const ReportFollowUpRepository = {
  GetAll,
  GetAllCardsReport,
  ExportAllCardsReport
}

export default ReportFollowUpRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/reportFollowUp.js